/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/*
* ==========FAQ============
*/
function faqCategoryChange(catId) {
  /*
  * Switch FAQ Category Nav
  */
  let catNavs = document.querySelectorAll(".faq-nav-wrapper .faq-cat-nav");
  for (let i = 0; i < catNavs.length; i++) {
    let navEle = catNavs[i];
    if (navEle.getAttribute("categoryid") === catId) {
      navEle.classList.add("active");
    } else {
      navEle.classList.remove("active");
    }
  }

  /*
  * Switch FAQ Category Content
  */
  let catContents = document.querySelectorAll(".faq_content_wrapper .faq__item");
  for (let i = 0; i < catContents.length; i++) {
    let faqItem = catContents[i];
    if (faqItem.getAttribute("categoryid") === catId) {
      faqItem.classList.add("active");
    } else {
      faqItem.classList.remove("active");
    }
  }
}
/*
* ==========FAQ============
*/

$( document ).ready(function() {
  console.log('-----------------');
});
                    
$(".choose-model-content .model-item .choose-model-img").click(function(){
  var shade = $(this).attr('data-shade');
  $(".find-shade-results").show();
  $(".choose-model-content .model-item .choose-model-img").removeClass("shade-active");
  $(this).addClass("shade-active");
  $('.find-shade-results-products .find-variant-result').hide();
  $('.find-shade-results-products .find-variant-result.data-model-'+shade+'-number').show();
  $('html, body').animate({ scrollTop: $("#find-shade-results-section").offset().top - 100 }, 1000);
});

// Disable Rebuy
document.addEventListener("rebuy:smartcart.ready", () => {
  Rebuy.SmartCart.destroy();
});

const _UTILS = {
  async AddItemsToCart(items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  },
  RefreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    let $cart_toggle = document.querySelector('[is="toggle-link"][aria-controls="mini-cart"]');
    if (!$cart_toggle) return;
    $cart_toggle.dispatchEvent(new Event('click'));
  }
};
document.addEventListener('alpine:init', () => {
  Alpine.data('ProductMain', () => ({
    qty: 1,
    purchaseOption: 'one-time',
    selling_plan: '',
    flags: {
      is_Onetime: true
    },
    init() {
      this.InitWatchers();
      this.ProductMediaHeight();
    },
    InitWatchers() {
      let am = this;
      am.$watch('purchaseOption', () => {
        am.flags.is_Onetime = am.purchaseOption == 'one-time';
        am.UpdateRCWidget();
        am.$nextTick(() => {
          am.selling_plan = am.flags.is_Onetime ? '' : am.$el.querySelector('.product-form__sub-widget [name=selling_plan]').value;
        });
      });

      if (this.$el.dataset.template_suffix == 'bundle-set') {
        UpdateImage = ($checked) => {
          const option = $checked.getAttribute('name');
          const value = $checked.value.toLowerCase();
          let match_alt_text = '';
          if (option == 'option1') {
            match_alt_text = `#standard color_${value}`;
          }
          if (option == 'option2') {
            match_alt_text = `#mini color_${value}`;
          }
          // console.log(match_alt_text)

          let $thumbs = document.querySelectorAll(`.product__thumbnail-item img[alt*="${match_alt_text}"]`);
          document.querySelectorAll(`.product__thumbnail-item img[alt*="#"]`).forEach($img => {
            let $thumb = $img.closest('.product__thumbnail-item');
            $thumb.classList.add('is-filtered');
          });
          $thumbs.forEach($img => {
            let $thumb = $img.closest('.product__thumbnail-item');
            $thumb.classList.remove('is-filtered');
            $thumb.dispatchEvent(new Event('click', {bubbles: true}));
          });
        }
        am.$el.querySelectorAll('product-variants .color-swatch').forEach($swatch => {
          $swatch.addEventListener('click', Alpine.debounce((e) => {
            // console.log(e);
            let $checked = e.target;
            UpdateImage($checked);
          }));
        });
        am.$el.querySelector('product-variants').addEventListener('change', (e) => {
          UpdateImage(e.target);
        });
      }
    },
    UpdateRCWidget() {
      let am = this;
      let $rc_widget = am.$el.querySelector('.rc-template__radio-group');
      if (!$rc_widget) return;
      if (am.flags.is_Onetime) {
        let $value = $rc_widget.querySelector('[value="onetime"]');
        $value.checked = true;
        $value.dispatchEvent(new Event('change', {bubbles: true}));
      }
      else {
        let $value = $rc_widget.querySelector('[value="subsave"]');
        $value.checked = true;
        $value.dispatchEvent(new Event('change', {bubbles: true}));
      }
    },
    ProductMediaHeight() {
      let am = this;
      let $mediaBlock = am.$el.querySelector('.product__media');
      let $mediaGallery = am.$el.querySelector('.product__media-list-wrapper');
      let offset = 25;
      $mediaBlock.style.setProperty('--mediaHeight', `${$mediaGallery.offsetHeight + offset}px`);
    }
  }));

  Alpine.data('FrequentlyBought', () => ({
    items: [],
    items_to_add: [],
    total_price: 0,
    total_price_money: '$00.00',
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {},
    InitWatchers() {
      let am = this;
      am.$watch('items', am.Calculate.bind(am));
    },
    Calculate() {
      let am = this;
      am.items_to_add = am.items.filter(item => item.qty > 0);
      am.total_price = am.items_to_add.reduce((sum, item) => {
        return sum + item.variant.price * item.qty;
      }, 0);
      am.total_price_money = formatMoney(am.total_price);
    },
    async e_AddItemsToCart() {
      let am = this;
      let items_to_add = am.items_to_add.map(item => {
        return {
          id: item.variant.id,
          quantity: item.qty
        };
      });
      await _UTILS.AddItemsToCart(items_to_add);
      _UTILS.RefreshCart();
    },
    e_QtyChanged(e) {
      let am = this;
      let added_item = am.items.find(item => item.variant.id == e.detail.variant.id)
      if (added_item) {
        added_item.qty = e.detail.qty;
      }
      else {
        am.items.push(e.detail);
      }
    }
  }));

  Alpine.data('FB_ProductCard', () => ({
    product: null,
    variant_id: '',
    selected_variant: null,
    qty: 0,
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.qty = 1; // preload as quantity = 1
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
      am.variant_id = am.product.variants.find(v => v.id == am.$el.querySelector('[name="id"]').value).id;
      if (am.product.variants.length == 1) {
        am.variant_id = am.product.variants[0].id;
        am.product.variants[0].featured_image = {
          src: am.product.featured_image
        }
      }
      am.SetSelectedVariant();
    },
    InitWatchers() {
      let am = this;
      am.$watch('variant_id', am.SetSelectedVariant.bind(am));
      am.$watch('qty', () => {
        am.$dispatch('qty-changed', {
          variant: am.selected_variant,
          qty: am.qty
        });
      });
    },
    SetSelectedVariant() {
      let am = this;
      am.selected_variant = am.product.variants.find(v => v.id == am.variant_id);
    }
  }));

  Alpine.data('TrustpilotRating', () => ({
    e_ScrollTo() {
      let $reviews = document.querySelector('.liquid .trustpilot-widget');
      if (!$reviews) return;

      window.scrollTo({
        top: $reviews.offsetTop,
        behavior: 'smooth'
      });
    }
  }));

  Alpine.data('MultiImageSwiper', () => ({
    init() {
      this.InitSwiper();
    },
    InitSwiper() {
      let am = this;
      new Swiper(am.$el.querySelector('.swiper'), {
        slidesPerView: 1.25,
        spaceBetween: 10,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: am.$el.querySelector('.swiper-button-next'),
          prevEl: am.$el.querySelector('.swiper-button-prev'),
        },        
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 25
          }
        }
      });      
    }
  }));

  Alpine.data('InfiniteLoader', () => ({
    cache: {},
    paginate: null,
    section_id: '',
    flags: {
      loadNextPage: false,
      allPagesLoaded: false
    },
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
      am.CheckStatus();
    },
    InitSelf() {
      let am = this;
      am.paginate = JSON.parse(am.$el.dataset.paginate);
      am.section_id = am.$el.dataset.section_id;
      am.cache.$section = am.$el.closest(`[section-id="${am.section_id}"]`);

      _UTILS.ObserveIntersection(am.$el, {}, (entries) => {
        // console.log(entries)
        let entry = entries[0];
        am.flags.loadNextPage = !am.flags.allPagesLoaded && entry.isIntersecting;
      });
    },
    InitWatchers() {
      let am = this;
      am.$watch('flags.loadNextPage', am.LoadNextPage.bind(am));
    },
    CheckStatus() {
      let am = this;
      am.flags.allPagesLoaded = am.paginate.current_page >= am.paginate.pages;
    },
    async LoadNextPage() {
      let am = this;
      if (!am.flags.loadNextPage) return;

      let nextPageUrl = `${am.paginate.next.url}&sections=${am.section_id}`;
      let res_json = await fetch(nextPageUrl).then(res => res.json());
      let res = res_json[am.section_id];
      let $res = _UTILS.ConvertStringToHTML(res);

      let $products = $res.querySelectorAll('.product-item');
      let $pagination = $res.querySelector('.pagination');

      // add products
      $products.forEach(($product) => {
        am.cache.$section.querySelector('.product-list__inner').insertAdjacentElement('beforeend', $product);
      });

      // replace pagination
      am.$el.outerHTML = $pagination.outerHTML;
    }
  }));

  Alpine.data('ShadeAddtoCart', () => ({
    async e_AddToCart(e) {
      // console.log(e);
      let items_to_add = [
        {
          id: e.currentTarget.dataset.variant,
          quantity: 1
        }
      ];
      await _UTILS.AddItemsToCart(items_to_add);
      _UTILS.RefreshCart();
    }
  }));
});